let lastScrollTop = 0;
const toggleHeader = () => {

    const header = document.getElementById('mainHeader');
    if(!header) return;

    const minScroll = 5;
    const pixelStart = 100;
    const scroll = window.scrollY;
    const white = header.classList.contains('main-header--white')

    // Minimal scroll block
    if (Math.abs(lastScrollTop - scroll) <= minScroll) return;

    if(scroll > pixelStart + 100 && white) {
        header.classList.add('main-header--bg');
    } else if (white) {
        header.classList.remove('main-header--bg');
    }

    if(scroll > lastScrollTop && scroll > pixelStart) {
        document.body.classList.add('main-header--hide')
    } else {
        document.body.classList.remove('main-header--hide')
    }

    lastScrollTop = scroll;
}
["load", "scroll"].forEach(function (evt) {
    window.addEventListener(evt, toggleHeader);
});
